<template>
  <div style="padding-top:-2px;margin-top:-2px;">
    <v-label><b>{{ label }}</b></v-label>
    <v-autocomplete
      v-model="internalValue"
      :items="items"
      :loading="isLoading"
      :search-input.sync="search"
      :disabled="disabled"
      hide-no-data
      hide-selected
      item-text="displayText"
      item-value="CgeID"
      :placeholder="placeholder"
      clearable
      outlined
      dense
      hide-details="auto"
      @change="onChange"
    >
      <template v-slot:no-data>
        <v-list-item>
          <v-list-item-title>
            Escriba la serie del equipo...
          </v-list-item-title>
        </v-list-item>
      </template>
      <template v-slot:item="{ item }">
        <v-list-item-content>
          <v-list-item-title>{{ item.CgeSerie }} - {{ item.CgeTypeEquipmentName }} - {{ item.CgeBrandName }}</v-list-item-title>
        </v-list-item-content>
      </template>
      <template v-slot:selection="{ item }">
        {{ item.CgeSerie }} - {{ item.CgeTypeEquipmentName }} - {{ item.CgeBrandName }}
      </template>
    </v-autocomplete>
  </div>
</template>

<script>
import _serviceTicEquipment from "@/services/InformationTechnology/TicEquipmentService.js";

export default {
  name: "sSelectEquipmentSerie",
  props: {
    value: null, // ID del equipo CgeID
    label: {
      type: String,
      default: "Equipo (por Serie)",
    },
    placeholder: {
      type: String,
      default: "Buscar serie...",
    },
    initialItem: {
      type: Object,
      default: () => null
    },
    ntpId: {
      type: Number,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isLoading: false,
      items: [],
      search: null,
      internalValue: null,
      timeout: null,
    };
  },
  watch: {
    value: {
      handler(val) {
        this.internalValue = val;
        // Cargar el item inicial si se edita un registro existente que ya tiene equipo guardado
        if (val && this.items.length === 0 && this.initialItem && this.initialItem.CgeID === val) {
           this.items = [{
             ...this.initialItem,
             displayText: `${this.initialItem.CgeSerie} - ${this.initialItem.CgeTypeEquipmentName} - ${this.initialItem.CgeBrandName}`
           }];
        }
      },
      immediate: true,
    },
    ntpId: {
      handler(newVal) {
        if (newVal) {
          this.fetchData("");
        }
      },
      immediate: true
    },
    search(val) {
      // Si no hay ntpId, exigimos al menos 2 caracteres
      if (!this.ntpId && (!val || val.length < 2)) return;
      
      const selectedItem = this.items.find(x => x.CgeID === this.internalValue);
      if (selectedItem && val === selectedItem.displayText) return;

      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.fetchData(val || "");
      }, 500); 
    },
  },
  methods: {
    fetchData(query) {
      this.isLoading = true;
      let params = { Search: query };
      if (this.ntpId) {
        params.NtpID = this.ntpId;
      }
      
      _serviceTicEquipment.findBySerie(params, this.$fun.getUserID())
        .then((response) => {
          if (response.status === 200) {
            this.items = response.data.map(item => ({
              ...item,
              displayText: `${item.CgeSerie} - ${item.CgeTypeEquipmentName} - ${item.CgeBrandName}`
            }));
          } else {
            this.items = [];
          }
        })
        .catch(() => {
          this.items = [];
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    onChange(val) {
      this.$emit("input", val);
      let selectedItem = this.items.find(x => x.CgeID === val);
      this.$emit("change", selectedItem);
    },
  },
};
</script>
